import React from 'react';
import Carousel from './base';
import { SmallPrevArrow, SmallNextArrow } from './arrows';

const defaultSliderSettings = {
  slidesToShow: 7,
  slidesToScroll: 7,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 5 } },
    { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 4 } },
    { breakpoint: 576, settings: { slidesToShow: 3, slidesToScroll: 3 } },
    { breakpoint: 384, settings: { slidesToShow: 2, slidesToScroll: 2 } }
  ]
};

export default function LargeCarousel(props) {
  const sliderSettings = {
    ...defaultSliderSettings,
    lazyLoad: false,
    prevArrow: <SmallPrevArrow />,
    nextArrow: <SmallNextArrow />
  };

  return <Carousel {...sliderSettings} {...props} />;
}

export { defaultSliderSettings };
